import {
  DEFAULT_ERRORS,
  opErrorBuilderFactory,
} from '@hc-frontend/core-utils-business-operation';

import { FEATURES_LOGGER_ERRORS } from './error-catalog';

export const errorCatalog = [
  ...DEFAULT_ERRORS,
  ...Object.keys(FEATURES_LOGGER_ERRORS).map((key) => ({
    error: key,
    description:
      FEATURES_LOGGER_ERRORS[key as keyof typeof FEATURES_LOGGER_ERRORS],
  })),
] as const;

export const errorBuilder = opErrorBuilderFactory({
  errorCatalog,
});
